import React from "react";

import { setSelectedIndex, setSelectedSkill } from "../actions";

import green from "../images/green_sm.gif";
import bright from "../images/bf_sm.png";

import { find } from "lodash";

const SearchResults = ({ jobs, selectedIndex, clusters, dispatch }) => {
    function handleClick(index) {
        dispatch(setSelectedIndex(index));
        dispatch(setSelectedSkill(null));
    }

    return (
        <div className="container search-results px-0">
            <div className="row">
                <div className="col font-weight-bold">
                    Search Results ({jobs.length})
                </div>
            </div>
            <div className="row search-results-table">
                <div className="col">
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="text-nowrap sticky-top">
                                    O*Net Code
                                </th>
                                <th className="sticky-top">Title</th>
                                <th className="sticky-top">Career Cluster</th>
                                <th className="sticky-top">Special</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.map((job, i) => (
                                <tr
                                    key={job.soc_code}
                                    onClick={handleClick.bind(this, i)}
                                    className={
                                        i === selectedIndex ? "selected" : ""
                                    }
                                >
                                    <td className="text-nowrap">
                                        {job.soc_code}
                                    </td>
                                    <td>{job.job_title}</td>
                                    <td>
                                        {job.clusters &&
                                            job.clusters
                                                .map(
                                                    (cluster_tag) =>
                                                        find(clusters, {
                                                            cluster_tag,
                                                        }).cluster_desc
                                                )
                                                .join("; ")}
                                    </td>
                                    <td>
                                        {job.is_green ? (
                                            <img src={green} alt="green" />
                                        ) : (
                                            <React.Fragment />
                                        )}{" "}
                                        {job.is_bright ? (
                                            <img
                                                src={bright}
                                                alt="Bright Outlook"
                                            />
                                        ) : (
                                            <React.Fragment />
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-sm">
                    Click on a profile to learn more about it.
                </div>
            </div>
        </div>
    );
};

export default SearchResults;
